import { render, staticRenderFns } from "./RatingsChart.vue?vue&type=template&id=00b693b4&"
import script from "./RatingsChart.vue?vue&type=script&lang=js&"
export * from "./RatingsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports